// extracted by mini-css-extract-plugin
export default {"editorNew":"Editor_editorNew__YQQV5"};